(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["np-card"] && !Shopify.designMode) return;
  try {
    // Quantity stepper — one delegated listener per page (snippet scripts inject once).
  if (!window.__npCardQtyBound) {
    window.__npCardQtyBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-np-qty-btn]');
      if (!btn) return;
      var wrap = btn.closest('[data-np-qty]');
      var input = wrap && wrap.querySelector('input[name="quantity"]');
      if (!input) return;
      var min = parseInt(input.min || '1', 10) || 1;
      var next = (parseInt(input.value, 10) || min) + parseInt(btn.dataset.npQtyBtn, 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  } catch(e) { console.error(e); }
})();

})();
